"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTimerPayload = exports.EOsceStage = exports.EOsceTimerState = exports.EOsceMarksheetState = exports.EOsceMarksheetAction = exports.EOsceRoles = void 0;
const utils_1 = require("../utils");
var EOsceRoles;
(function (EOsceRoles) {
    EOsceRoles[EOsceRoles["ALL"] = 0] = "ALL";
    EOsceRoles[EOsceRoles["CANDIDATE"] = 1] = "CANDIDATE";
    EOsceRoles[EOsceRoles["ACTOR"] = 2] = "ACTOR";
    EOsceRoles[EOsceRoles["EXAMINER"] = 3] = "EXAMINER";
    EOsceRoles[EOsceRoles["OBSERVER"] = 4] = "OBSERVER";
})(EOsceRoles = exports.EOsceRoles || (exports.EOsceRoles = {}));
var EOsceMarksheetAction;
(function (EOsceMarksheetAction) {
    EOsceMarksheetAction[EOsceMarksheetAction["PRESTART"] = 0] = "PRESTART";
    EOsceMarksheetAction[EOsceMarksheetAction["START"] = 1] = "START";
    EOsceMarksheetAction[EOsceMarksheetAction["END"] = 2] = "END";
    EOsceMarksheetAction[EOsceMarksheetAction["PAUSE"] = 3] = "PAUSE";
    EOsceMarksheetAction[EOsceMarksheetAction["CONTINUE"] = 4] = "CONTINUE";
    EOsceMarksheetAction[EOsceMarksheetAction["CONNECT"] = 5] = "CONNECT";
    EOsceMarksheetAction[EOsceMarksheetAction["DISCONNECT"] = 6] = "DISCONNECT";
    EOsceMarksheetAction[EOsceMarksheetAction["SELECT"] = 7] = "SELECT";
    EOsceMarksheetAction[EOsceMarksheetAction["LEFT"] = 8] = "LEFT";
    EOsceMarksheetAction[EOsceMarksheetAction["KICK"] = 9] = "KICK";
    EOsceMarksheetAction[EOsceMarksheetAction["ROLE_CHANGE"] = 10] = "ROLE_CHANGE";
    EOsceMarksheetAction[EOsceMarksheetAction["STATE_CHANGE"] = 11] = "STATE_CHANGE";
})(EOsceMarksheetAction = exports.EOsceMarksheetAction || (exports.EOsceMarksheetAction = {}));
var EOsceMarksheetState;
(function (EOsceMarksheetState) {
    EOsceMarksheetState[EOsceMarksheetState["LOBBY"] = 0] = "LOBBY";
    EOsceMarksheetState[EOsceMarksheetState["STATION_BUILDER"] = 1] = "STATION_BUILDER";
    EOsceMarksheetState[EOsceMarksheetState["PRESTART"] = 2] = "PRESTART";
    EOsceMarksheetState[EOsceMarksheetState["STATION"] = 3] = "STATION";
    EOsceMarksheetState[EOsceMarksheetState["RESULT"] = 4] = "RESULT";
})(EOsceMarksheetState = exports.EOsceMarksheetState || (exports.EOsceMarksheetState = {}));
var EOsceTimerState;
(function (EOsceTimerState) {
    EOsceTimerState[EOsceTimerState["START"] = 0] = "START";
    EOsceTimerState[EOsceTimerState["PAUSE"] = 1] = "PAUSE";
    EOsceTimerState[EOsceTimerState["COMPLETED"] = 2] = "COMPLETED";
})(EOsceTimerState = exports.EOsceTimerState || (exports.EOsceTimerState = {}));
var EOsceStage;
(function (EOsceStage) {
    EOsceStage[EOsceStage["READING"] = 0] = "READING";
    EOsceStage[EOsceStage["STATION"] = 1] = "STATION";
    EOsceStage[EOsceStage["FEEDBACK"] = 2] = "FEEDBACK";
})(EOsceStage = exports.EOsceStage || (exports.EOsceStage = {}));
function createTimerPayload(osceMarksheet) {
    const payload = {
        osceMarksheetId: osceMarksheet.id,
        sessionId: osceMarksheet.sessionId,
        timeRemaining: '00:00',
        totalStationTime: '00:00',
        stageTime: '/00 secs',
        stage: EOsceStage.READING,
        state: EOsceTimerState.PAUSE,
    };
    if (!osceMarksheet.endedAt ||
        !osceMarksheet.readingTime ||
        !osceMarksheet.stationTime ||
        !osceMarksheet.feedbackTime) {
        return payload;
    }
    payload.state = EOsceTimerState.START;
    const stationDuration = osceMarksheet.readingTime +
        (osceMarksheet.stationTime + osceMarksheet.feedbackTime) * 60;
    payload.totalStationTime = (0, utils_1.printDuration)(stationDuration);
    let endedAt;
    if (typeof osceMarksheet.endedAt === 'number') {
        endedAt = osceMarksheet.endedAt;
    }
    else {
        endedAt = Math.floor(new Date(osceMarksheet.endedAt).getTime() / 1000);
    }
    // calculate duration from pause timestamp or from current time
    let timeRemainingDuration = endedAt - Math.floor(Date.now() / 1000);
    if (osceMarksheet.completed || timeRemainingDuration < 0) {
        payload.state = EOsceTimerState.COMPLETED;
    }
    if (osceMarksheet.pausedAt) {
        let pausedAt;
        if (typeof osceMarksheet.pausedAt === 'number') {
            pausedAt = osceMarksheet.pausedAt;
        }
        else {
            pausedAt = Math.floor(new Date(osceMarksheet.pausedAt).getTime() / 1000);
        }
        timeRemainingDuration = endedAt - pausedAt;
        payload.state = EOsceTimerState.PAUSE;
    }
    if (timeRemainingDuration > stationDuration - osceMarksheet.readingTime) {
        payload.stage = EOsceStage.READING;
        payload.stageTime = `/${osceMarksheet.readingTime} secs`;
    }
    else if (timeRemainingDuration >
        stationDuration - osceMarksheet.readingTime - osceMarksheet.stationTime * 60) {
        payload.stage = EOsceStage.STATION;
        payload.stageTime = `/${osceMarksheet.stationTime} mins`;
    }
    else {
        payload.stage = EOsceStage.FEEDBACK;
        payload.stageTime = `/${osceMarksheet.feedbackTime} mins`;
    }
    payload.timeRemaining = (0, utils_1.printDuration)(timeRemainingDuration);
    return payload;
}
exports.createTimerPayload = createTimerPayload;
